import React from 'react';
import { Box, Typography } from '@mui/material';
import { VisitCalendar } from './components/VisitCalendar';
import { VisitDocumentation } from './components/VisitDocumentation';
import { VisitMap } from './components/VisitMap';
import { FollowUpTracker } from './components/FollowUpTracker';
import { useVisits } from './hooks/useVisits';
import { Visit } from './types';

export const HomeVisitManagement: React.FC = () => {
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { visits, addVisit, updateVisit } = useVisits();
  const [selectedVisit, setSelectedVisit] = React.useState<Visit | null>(null);

  const handleSaveVisit = (visit: Visit) => {
    if (selectedVisit) {
      updateVisit(visit);
    } else {
      addVisit(visit);
    }
    setSelectedVisit(null);
  };

  const handleVisitSelect = (visit: Visit) => {
    setSelectedVisit(visit);
  };

  const handleClearSelection = () => {
    setSelectedVisit(null);
  };

  return (
    <Box sx={{ 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column',
      gap: 3,
      p: 3,
      overflow: 'hidden'
    }}>
      <Typography variant="h4" component="h1">
        Home Visit Management
      </Typography>

      <Box sx={{ 
        flexGrow: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: 3
      }}>
        {/* Left Column - Documentation and Follow-ups */}
        <Box sx={{ 
          width: { xs: '100%', md: '35%' },
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          minHeight: 0
        }}>
          {/* Documentation Section */}
          <Box sx={{ 
            height: '60%',
            minHeight: { xs: 400, md: 0 }
          }}>
            <VisitDocumentation 
              onSave={handleSaveVisit}
              selectedVisit={selectedVisit}
              onClear={handleClearSelection}
            />
          </Box>

          {/* Follow-up Section */}
          <Box sx={{ 
            height: '40%',
            minHeight: { xs: 300, md: 0 }
          }}>
            <FollowUpTracker visits={visits} />
          </Box>
        </Box>

        {/* Right Column - Calendar and Map */}
        <Box sx={{ 
          width: { xs: '100%', md: '65%' },
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          minHeight: 0
        }}>
          {/* Calendar Section */}
          <Box sx={{ 
            height: '60%',
            minHeight: { xs: 400, md: 0 }
          }}>
            <VisitCalendar 
              visits={visits} 
              onVisitSelect={handleVisitSelect}
            />
          </Box>

          {/* Map Section */}
          <Box sx={{ 
            height: '40%',
            minHeight: { xs: 300, md: 0 }
          }}>
            <VisitMap visits={visits} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};